import React, { useEffect, useContext } from 'react'
import DefaultCarousel from './DefaultCarousel'
import FullScreenCarousel from './FullScreenCarousel'
import { CarouselContext, CarouselProvider } from './CarouselContext'
import './styles.scss'

const ImageCarousel = () => {
    const {
        currentIndex,
        handleScroll,
        imageRefs,
        fsImageRefs,
        galleryImages,
        defaultCarouselRef,
        fullscreenCarouselRef,
        isFullScreen,
        enableRotate = false,
        loading
    } = useContext(CarouselContext)

    useEffect(() => {
        // Add event listeners to all images
        Object.values(imageRefs.current).forEach(imageElement => {
            if (imageElement) {
                imageElement.addEventListener('wheel', handleScroll, { passive: false })
            }
        })

        Object.values(fsImageRefs.current).forEach(imageElement => {
            if (imageElement) {
                imageElement.addEventListener('wheel', handleScroll, { passive: false })
            }
        })

        // Cleanup
        return () => {
            Object.values(imageRefs.current).forEach(imageElement => {
                if (imageElement) {
                    imageElement.removeEventListener('wheel', handleScroll)
                }
            })
            Object.values(fsImageRefs.current).forEach(imageElement => {
                if (imageElement) {
                    imageElement.removeEventListener('wheel', handleScroll)
                }
            })
        }
    }, [galleryImages, currentIndex, isFullScreen])


    if (!galleryImages?.length) {
        return null
    }

    return (
        <div className="ratioHolder slide-container">
            <DefaultCarousel ref={defaultCarouselRef} enableRotate={enableRotate} loading={loading} />
            <FullScreenCarousel ref={fullscreenCarouselRef} loading={loading} />
        </div>
    )
}

export default ({
    images,
    enableRotate = false,
    handleReload = () => {},
    setLoading = () => {},
    userId,
    setImage = () => {},
    loading = false
}) => (
    <CarouselProvider
        images={images}
        enableRotate={enableRotate}
        handleReload={handleReload}
        setLoading={setLoading}
        loading={loading}
        userId={userId}
        setImage={setImage}
    >
        <ImageCarousel />
    </CarouselProvider>
)
